import {useMutation} from "@tanstack/react-query";
import {completeCustomerOfferCoefficientReviewMutationOptions} from "./complete-customer-offer-coefficient-review.mutation-options";

export function useCompleteCustomerOfferCoefficientReview() {
  return useMutation(completeCustomerOfferCoefficientReviewMutationOptions());
}
